const databases = [
    {
        name: 'MongoDB',
        imgUrl: '/technologies/mongodb.svg'
    },
    {
        name: 'MySQL',
        imgUrl: '/technologies/mysql.svg'
    },
    {
        name: 'MariaDB',
        imgUrl: '/technologies/mariadb.svg'
    },
    {
        name: 'PosgreSQL',
        imgUrl: '/technologies/postgre.png'
    }
]

export default databases